import type { FC, ReactNode } from 'react';

import { Check } from 'lucide-react';

import { cn } from '@shared/utils';

import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '../dropdown-menu';

export interface DropdownOption {
  label: string;
  value: string;
  disabled?: boolean;
  suffix?: ReactNode;
  className?: string;
  'data-testid'?: string;
  isSelected?: (value: string) => boolean;
}

interface GenericDropdownProps {
  options: DropdownOption[];
  onClick: (value: string) => void;
  trigger: ReactNode;
  'data-testid'?: string;
}

export const GenericDropdown: FC<GenericDropdownProps> = ({ trigger, options, onClick, 'data-testid': dataTestId }) => (
  <DropdownMenu>
    <DropdownMenuTrigger asChild>{trigger}</DropdownMenuTrigger>
    <DropdownMenuContent align="end" data-testid={dataTestId}>
      {options.map((option) => (
        <DropdownMenuItem
          key={option.value}
          onClick={() => !option.disabled && onClick(option.value)}
          disabled={option.disabled}
          className={cn(option.className, 'cursor-pointer')}
          data-testid={option['data-testid']}
        >
          <span className="flex items-center gap-2">
            <span>{option.label}</span>
            {option.suffix}
            {option.isSelected?.(option.value) && <Check className="h-4 w-4 text-primary" />}
          </span>
        </DropdownMenuItem>
      ))}
    </DropdownMenuContent>
  </DropdownMenu>
);
